import { render } from "./NewsDetailJun2024Page.vue?vue&type=template&id=b36db81e"
import script from "./NewsDetailJun2024Page.vue?vue&type=script&lang=js"
export * from "./NewsDetailJun2024Page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__